import { VStack, Text } from "@chakra-ui/react";
import { useSchoolsContext } from "../../../../Contexts/schoolContext";
import { User } from "../../../../services/Dtos";
import { useState } from "react";
import Loader from "../../../CustomUi/Loader";
import CustomAlert from "../../../CustomUi/CustomAlert";
import UserModal from "./UserModal";
import { useUserContext } from "../../../../Contexts/userContext";
import UsersTable from "./UsersTable";
import SectionHeader from "../../../CustomUi/SectionHeader";
import useIcons from "../../../../hooks/useIcons";
import useThemeColors from "../../../../hooks/useThemeColors";
import Cad from "../../../CustomUi/Cad";

function UserSettings() {
  const [userToEdit, setUserToEdit] = useState<User | null>(null);
  const { isLoading, error, accentColor } = useSchoolsContext();
  const { user } = useUserContext();
  const [openUserModal, setOpenUserModal] = useState(false);
  const icons = useIcons();
  const colors = useThemeColors();

  const handleRefresh = () => {
    // Refresh functionality can be implemented here
  };

  const handleAddUser = () => {
    setUserToEdit(null);
    setOpenUserModal(true);
  };

  const handleEditUser = (user: User) => {
    setUserToEdit(user);
    setOpenUserModal(true);
  };

  const handleCloseModal = () => {
    setOpenUserModal(false);
    setUserToEdit(null);
  };

  if (isLoading) {
    return <Loader />;
  }

  if (error) {
    return <CustomAlert message={error} handleClick={handleRefresh} />;
  }

  return (
    <VStack gap={8}>
      {/* Users Table for Admins */}
      {user?.role === 3 ? (
        <Cad minimal>
          <VStack gap={6} align="stretch">
            <SectionHeader
              title="Users"
              buttonText="Add User"
              onButtonClick={handleAddUser}
              buttonIcon={icons.utility.plus}
              buttonColorScheme={accentColor}
              icon={icons.people.users}
            />
            <UsersTable editUser={handleEditUser} />
          </VStack>
        </Cad>
      ) : (
        <Cad>
          <VStack gap={6} align="stretch">
            <SectionHeader title="Access Denied" icon={icons.people.users} />
            <Text color={colors.text.secondary} textAlign="center">
              You don't have permission to access user management. Please
              contact your administrator for assistance.
            </Text>
          </VStack>
        </Cad>
      )}
      <UserModal
        isOpen={openUserModal}
        onClose={handleCloseModal}
        userToEdit={userToEdit}
      />
    </VStack>
  );
}

export default UserSettings;
